<template>
    <div id="history-status">
        <v-ws v-on:onopen="initSearch" :sendMessage="sendMessage" v-on:vehicle_search="changeSearchData" ></v-ws>
        <el-popover
          ref="popover"
          placement="right"
          width="540"
          trigger="click"
          v-model="poverVisible"
          >
            <div class="pover-search">
                <v-search
                    v-on:select="searchSelectCurrent"
                    v-on:search="createVehicleSearch"
                    :serchData="serchData"
                    :showConfirmBt='true'
                    v-on:cancelSelect="cancelSelect"
                >
                </v-search>
            </div>
        </el-popover>
        <p >车辆历史数据</p>
        <el-row>
          <el-col :span="12">
            <p class="setting-title car">车辆选择</p>
            <el-button type="primary" v-popover:popover>选择车辆</el-button>
            <table class="car-table" cellspacing="0" cellpadding="0" >
              <tr>
                <td colspan="1" rowspan="2">当前车辆</td>
                <td>电池编码</td>
                <td>车牌号码</td>
                <td>厂家车辆编号</td>
              </tr>
              <tr>
                <td>A00001</td>
                <td>粤B-00001</td>
                <td>111158</td>
              </tr>
            </table>
          </el-col>
          <el-col :span="12">
            <p class="setting-title time">时间选择</p>
            <el-date-picker
                v-model="datetimerange"
                type="datetimerange"
                :picker-options="pickerOptions"
                placeholder="选择时间范围"
                align="right"
                @change="selectTimeChange">
            </el-date-picker>
          </el-col>
        </el-row>
        <p擦class="setting-title time">指标选择</p>
        <el-checkbox-group v-model="checkedTableHead" @change="handleCheckedTableHeadsChange">
            <el-checkbox v-for="tableHead in tableHeadsList" :label="tableHead.label" :key="tableHead.key" v-if="tableHead.show">{{tableHead.label}}</el-checkbox>
        </el-checkbox-group>
        <el-table
        :data="tableData"
        style="width: 100%">
            <el-table-column
                v-for="tableHead in tableHeads"
                :prop="tableHead.key"
                :key="tableHead.key"
                :label="tableHead.label">
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import search from '../plugins/search';
import ws from '../plugins/ws';
export default {
    name: 'history-status',
    created () {
    },
    components: {
        'v-search': search,
        'v-ws': ws
    },
    data () {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            datetimerange: [new Date((new Date()).getTime() - 3600 * 1000 * 24 * 7), new Date()],
            serchData: {},
            poverVisible: false,
            selectCar: {},
            sendMessage: {},
            checkedTableHead: ['elect', 'SOC'],
            tableHeads: [
                {
                    label: '电压',
                    key: 'elect'

                },
                {
                    label: 'SOC',
                    key: 'SOC'
                }
            ],
            tableData: [
                {
                    elect: '我是电压',
                    SOC: '我是电压50%'

                },
                {
                    elect: '我是电压',
                    SOC: '我是电压80%'

                }
            ],
            tableHeadsList: [
                {
                    label: '电压',
                    key: 'elect',
                    show: true

                },
                {
                    label: 'SOC',
                    key: 'SOC',
                    show: true
                }
            ]
        };
    },
    methods: {
        initSearch () {
            this.sendMessage = {
                topic: 'vehicle_search',
                action: 'create',
                data: {
                    battery_code: '',
                    plate_number: '',
                    production_vehicle_no: ''
                }
            };
        },
        cancelSelect () {
            this.poverVisible = false;
        },
        changeSearchData (data) {
            this.serchData = data;
        },
        createVehicleSearch (value) {
            this.sendMessage = {
                topic: 'vehicle_search',
                action: 'create',
                data: value
            };
        },
        searchSelectCurrent (car) {
            this.selectCar = car;
        },
        selectTimeChange (time) {

        },
        handleCheckedTableHeadsChange (headList) {
            var heads = [];
            for (var i = 0, lengi = this.tableHeadsList.length; i < lengi; i++) {
                for (var j = 0, lengj = headList.length; j < lengj; j++) {
                    if (this.tableHeadsList[i].key === headList[j]) {
                        heads.push(this.tableHeadsList[i]);
                        break;
                    }
                }
            }
            this.tableHeads = heads;
        }
    }
};
</script>
<style scoped>
#history-status{
    text-align: left;
    background-color: #fff;
    padding: 15px;
}

.el-button--primary{
    width: 90px;
    position: absolute;
    top:0;
    left: 475px;
}
.el-col-12{
    position: relative;
}
.setting-title{
    margin:10px 0;
}
.el-table{
    border:none;
    font-size: 12px;
    text-align: center;
}

</style>
<style>
#history-status .el-table th.is-leaf{
    border-bottom: none;
    font-weight: normal;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// history-status.vue?ec785838